var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseMyFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 30.625H24.5",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 30.625V13.125C3.5 6.125 5.25 4.375 12.25 4.375",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 30.625V13.125C38.5 6.125 36.75 4.375 29.75 4.375",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 27.8424V33.5999C17.5 37.0999 16.1 38.4999 12.6 38.4999H8.4C4.9 38.4999 3.5 37.0999 3.5 33.5999V27.8424C3.5 24.3424 4.9 22.9424 8.4 22.9424H12.6C16.1 22.9424 17.5 24.3424 17.5 27.8424Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 27.8424V33.5999C38.5 37.0999 37.1 38.4999 33.6 38.4999H29.4C25.9 38.4999 24.5 37.0999 24.5 33.5999V27.8424C24.5 24.3424 25.9 22.9424 29.4 22.9424H33.6C37.1 22.9424 38.5 24.3424 38.5 27.8424Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseMyFrame1);
export default __webpack_public_path__ + "static/media/use_my_frame1.26e78b05d9b001cc9f7c1cd95428b1c4.svg";
export { ForwardRef as ReactComponent };